module.exports = __webpack_public_path__ + "img/logout.d28daa1f.svg";